import userRestRepository from "common/user/repository/UserRestRepository";
import React, {Suspense} from "react";
import CommonUtil from "utils/CommonUtil";
import Button, {AbstractButton, ButtonProps} from "components/buttons";
import PageLoading from "../loading";

export interface KmcisConfirmResult {
    phoneNo: string;
    phoneCorp: string;
    birthDay: string;
    nation: string;
    gender: string;
    name: string;
}

interface KmcisLinkProps {
    urlCodeType: "0" | "1" | "2" | "3" | "4" | "5";
    color?: ButtonProps["color"];
    size?: AbstractButton["size"];
    className?: string;
    preCheck?(): boolean;
    callback(result: KmcisConfirmResult, confirmed: boolean): void;
    children?: React.ReactNode;
}

export default KmcisLink;

/**
 * www.kmcert.com -> 회원사 전용
 * id: WINM1001, pass: win12345 (변경될수있음)
 * 상세화면 경로 등록하여 코드 채번을 해야함. / 채번된 코드는 타입에 따라 config파일에 등록하여 사용
 */
function KmcisLink(props: KmcisLinkProps) {
    console.log("KmcisLink", "props", props);
    const [windowTarget] = React.useState("Kmcis_" + CommonUtil.getUid());
    const formRef = React.useRef<HTMLFormElement>(null);
    const [tr_cert, setTrCert] = React.useState<string>();
    const trCert = React.useDeferredValue(tr_cert);
    const trVer = "V2";
    const trUrl = window.location.origin + "/kmcis/confirm.jsp";

    React.useEffect(() => {
        (async () => {
            const trCert = await userRestRepository.getKmcisCert(props.urlCodeType);
            setTrCert(trCert);
        })();
    }, []);

    // gender > 0 남자, 1: 여자 nation > 0: 내국인, 1: 외국인
    window["KmcisConfirmCallback"] = (phoneNo: string, phoneCorp: string, birthDay: string, nation: string, gender: string, name: string, confirmed: boolean) => {
        props.callback({phoneNo, phoneCorp, birthDay, nation, gender, name}, confirmed);
    };

    const linkClickHandler = () => {
        if (props.preCheck) {
            if(props.preCheck()) {
                window.open("", `${windowTarget}`, "width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250");
                formRef.current!.submit();
                // props.callback({phoneNo: '', phoneCorp: '', birthDay: '', nation: '', gender: '', name: ''}, true);
            }
        }
        else {
            window.open("", `${windowTarget}`, "width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250");
            formRef.current!.submit();
            // props.callback({phoneNo: '', phoneCorp: '', birthDay: '', nation: '', gender: '', name: ''}, true);
        }
    }

    return (
        <Suspense fallback={<PageLoading/>}>
            <Button color={props.color} size={props.size} onClick={linkClickHandler} className={props.className}>
                {props.children || '휴대폰 본인인증'}
            </Button>
            <form ref={formRef} action='https://www.kmcert.com/kmcis/web/kmcisReq.jsp' method="POST"
                  target={`${windowTarget}`}>
                <input type="hidden" name="tr_cert" value={trCert}/>
                <input type="hidden" name="tr_url" value={trUrl}/>
                <input type="hidden" name="tr_ver" value={trVer}/>
            </form>
        </Suspense>
    )
}
